/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["message"];
import { useCallback, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getMessageId } from 'conversations-message-history/message-history/operators/getMessageId';
import { getGenericChannelIdForMessage } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { getCurrentGenericChannelId } from '../../tabbed-editors/selectors/getCurrentGenericChannelId';
import { clickedToForward } from 'composer-data/email/public/actions';
import { getForwardCommunicatorState } from 'composer-data/email/public/selectors';
import { useThreadDetails } from '../../thread-details-feature/public/hooks/useThreadDetails';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { isTestThread as isTestThreadOperator } from 'conversations-thread-data/thread-details/public/operators';
import { getCurrentThreadId } from 'conversations-thread-data/thread-details/public/selectors';
import { ForwardingContext } from '../context/ForwardingContext';

/**
 * @description A decorator component that provides asynchronously
 * loaded components required to run the communicator. It injects
 * a rendering function to show the forwarding communicator.
 * @param {Object} AsyncComponent components that the application
 * needs to code split and inject into the thread view
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const withCommunicator = WrappedComponent => props => {
  const {
      message
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    forwardingEnabled
  } = useContext(ForwardingContext);
  const dispatch = useDispatch();
  const currentChannelId = useSelector(getCurrentGenericChannelId);
  const {
    message: activeForwardMessage
  } = useSelector(getForwardCommunicatorState);
  const handleClickToForward = useCallback(() => {
    dispatch(clickedToForward({
      message,
      replyAll: true,
      isReply: false
    }));
  }, [dispatch, message]);
  const handleClickToReply = useCallback(() => {
    dispatch(clickedToForward({
      message,
      replyAll: false,
      isReply: true
    }));
  }, [dispatch, message]);
  const handleClickToReplyAll = useCallback(() => {
    dispatch(clickedToForward({
      message,
      replyAll: true,
      isReply: true
    }));
  }, [dispatch, message]);
  const highlight = getMessageId(message) === getMessageId(activeForwardMessage) && currentChannelId === getGenericChannelIdForMessage(activeForwardMessage);
  const threadId = useSelector(getCurrentThreadId);
  const {
    asyncThreadDetails
  } = useThreadDetails({
    threadId
  });
  const threadDetails = getData(asyncThreadDetails);
  const isTestThread = isTestThreadOperator(threadDetails);
  const emailForwardingProps = forwardingEnabled && !isTestThread ? {
    highlight,
    onClickToForward: handleClickToForward,
    onClickToReply: handleClickToReply,
    onClickToReplyAll: handleClickToReplyAll
  } : {};
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
    message: message
  }, rest, emailForwardingProps));
};